import { useEffect } from 'react';
import { NAV_KEYS } from './navKeys';

/**
 * useKeyHandler
 *
 * Base hook for keyboard navigation handlers.
 * Handles boilerplate: input field guard, key filtering, preventDefault,
 * and window event listener setup/cleanup.
 *
 * Subhooks (useKeyboardNav, useCrossNodeNav) call this with a handler
 * that receives { isUp, isDown, isPageUp, isPageDown, isBack } and acts on them.
 */
export default function useKeyHandler({ onKey, deps = [] }) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            const tag = document.activeElement?.tagName?.toLowerCase();
            if (['select', 'input', 'textarea'].includes(tag)) return;
            if (!NAV_KEYS.includes(e.key)) return;

            const isUp     = e.key === 'w' || e.key === 'W' || e.key === 'ArrowUp';
            const isDown   = e.key === 's' || e.key === 'S' || e.key === 'ArrowDown';
            const isBack   = e.key === 'a' || e.key === 'A' || e.key === 'Escape';
            const isPageUp   = e.key === 'PageUp'   && e.shiftKey;
            const isPageDown = e.key === 'PageDown' && e.shiftKey;

            if (isUp || isDown || isBack || isPageUp || isPageDown) e.preventDefault();

            onKey({ isUp, isDown, isBack, isPageUp, isPageDown });
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, deps);
}
